import React from "react";
import PropTypes from "prop-types";

import PrivateTopBarContainer from "../containers/PrivateTopBarContainer";
import FooterView from "../views/FooterView";


class PrivateWrapper extends React.Component {

    static propTypes = {
        children: PropTypes.object.isRequired,
        usesDefaultFooter: PropTypes.bool.isRequired
    };

    render() {
        let footer = null;
        if (this.props.usesDefaultFooter) {
            footer = (
                <div className="footer-contents mt-4">
                    <FooterView/>
                </div>
            );
        }

        return (
            <div className="main-contents">
                <PrivateTopBarContainer />
                <div className="middle-contents">
                    {this.props.children}
                </div>
                {footer}
            </div>
        );
    }
}

export default PrivateWrapper;